import React from "react";
import { useState, useEffect, useContext } from "react";
import { ImFolderDownload } from "react-icons/im";
import { chatsData } from "../data/whatsappchat";
import filterContext from "../context/filters/filterContext";
import Chat from "./Chat";
import "../styles/leftMenu.css";
import "../styles/chats.css";
// import { log } from 'winston';
import {
  Menu,
  Button,
  Input,
  Modal,
  Dropdown,
  Checkbox,
  Tooltip,
} from "antd/lib";
import { BiFilter } from "react-icons/bi";
import { DownOutlined } from "@ant-design/icons";
import Loader from "./Common/Loader";
import { setSideTab } from "../../../../toolkit/slices/inventories/inventorySlice";
import { useDispatch } from "react-redux";

function Chats({ rf }) {
  const {
    namePerson,
    setnamePerson,
    pimgLink,
    setpimgLink,
    setConveresationId,
    conversationdata,
    setConversationdata,
    fetchConversation,
    settogChat,
    setdescription,
    description,
    usersOfParticularGroup,
    setusersOfParticularGroup,
    sampledataa,
    setsampledataa,
    isLoading,
    shortcutConv,
    setShortcutConv,
  } = useContext(filterContext);
  // let userId = useSelector(state => state.api.UserData._id);
  const [chats, setChats] = useState(chatsData);
  const [searchQuery, setSearchQuery] = useState("");
  const [editSearchQuery, setEditSearchQuery] = useState("");
  const [filteredConversations, setFilteredConversations] = useState([]);
  const [filteredShortcutConv, setFilteredShortcutConv] = useState([]);
  const [allConversation, setAllConversation] = useState(true);
  const [broadcastModal, setBroadcastModal] = useState(false);
  const [editShortcutModal, setEditShortcutModal] = useState(false);
  const [modalConversations, setModalConversations] = useState([]);
  const [modalFilteredConversations, setModalFilteredConversations] = useState(
    []
  );
  const defaultDP = "https://s3.ap-south-1.amazonaws.com/avatars.prepleaf.com/u/628c8d587640243d911a71d4/kbVumlrcT6.svg";
  const [addConvBtn, setAddConvBtn] = useState(false);
  const dispatch = useDispatch();

  // const [conversation, setConversation] = useState([]);

  // useEffect(() => {
  //   fetchConversation();
  // }, []);
  const {
    reloadFlag,
    setReloadFlag,
    getMsg,
    filter,
    setfilter,
    customShortcutData,
    selectedConversations,
    setSelectedConversations,
    broadcastMsg,
    setBroadcastMsg,
    handleBroadcast,
    setShortcutId,
    deleteShortcut,
    addConvToShortcut,
    deleteConvFromShortcut,
    unreadFlag,
    setUnreadFlag,
    setSelectedFiles,
    setPreviewURLs,
    createdBy,
    setCreatedBy,
    createdAt,
    setCreatedAt,
    chatName,
  } = useContext(filterContext);
  useEffect(() => {
    setReloadFlag(false);
  }, [reloadFlag]);
  useEffect(() => {
    const newChats = filter
      ? chatsData.filter((chat) => chat.unreadMsgs)
      : chatsData;
    setChats(newChats);
  }, [filter]);
  useEffect(() => {}, [setConversationdata]);
  function handleChat(chat) {
    settogChat(true);
    setnamePerson(chatName(chat));
    setpimgLink(
      !chat.dp
        ? "https://s3.ap-south-1.amazonaws.com/avatars.prepleaf.com/u/6471ec801d1a71103fc8f669/XA9bTK8cou.png"
        : chat.dp
    );
    setConveresationId(chat.id);
    setdescription(chat.description);
    // console.log(chat.isRedFlag);
    setSelectedFiles([]);
    setPreviewURLs([]);
    console.log(getMsg);
  }
  useEffect(() => {}, [getMsg]);

  //useeffect for search functionality
  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      const lowerCaseQuery = searchQuery.toLowerCase();
      if (allConversation && conversationdata != undefined) {
        const filteredConversations = conversationdata.filter((chat) => {
          const { name } = chat;
          return name.toLowerCase().includes(lowerCaseQuery);
        });
        setFilteredConversations(filteredConversations);
      } else {
        const filteredShortcutConv = shortcutConv.filter((chat) => {
          const { name } = chat;
          return name.toLowerCase().includes(lowerCaseQuery);
        });
        setFilteredShortcutConv(filteredShortcutConv);
      }
    }, 300);

    return () => {
      clearTimeout(debounceSearch);
    };
  }, [searchQuery, conversationdata, shortcutConv]);

  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      const lowerCaseQuery = editSearchQuery.toLowerCase();
      const modalFilteredConversations = modalConversations.filter((chat) => {
        const { name } = chat;
        return name.toLowerCase().includes(lowerCaseQuery);
      });
      setModalFilteredConversations(modalFilteredConversations);
    }, 300);

    return () => {
      clearTimeout(debounceSearch);
    };
  }, [editSearchQuery, modalConversations]);

  useEffect(() => {
    dispatch(setSideTab(window.location.pathname));
  }, []);

  //to handle the search query
  const handleInputChange = (e) => {
    if (editShortcutModal) {
      setEditSearchQuery(e.target.value);
    } else {
      setSearchQuery(e.target.value);
    }
  };

  // conversationdata.map((ele)=>{
  // 	fetchConversation(ele._id)
  // 	let count  = getMsg.length;
  // 	console.log(count);
  // })
  //to handle broadcast btn click
  const handleBroadcastModal = () => {
    setBroadcastModal(true);
    const allConvIds = shortcutConv.map((chat) => chat._id);
    setSelectedConversations(allConvIds);
  };

  //to set the broadcastmsg
  const handleBroadcastMsg = (e) => {
    setBroadcastMsg(e.target.value);
  };

  const handleCancel = () => {
    setSelectedConversations([]);
    setBroadcastMsg("");
    setBroadcastModal(false);
    setEditShortcutModal(false);
    setModalConversations([]);
    setEditSearchQuery("");
    setModalFilteredConversations([]);
  };

  //to handle edit shortcut(add or remove conversation)
  const handleEditShortcut = (key) => {
    if (key === 2) {
      setAddConvBtn(true);
      const modalConversations = filteredConversations.filter(
        (chat) => !shortcutConv.find((conv) => conv._id === chat._id)
      );
      setModalConversations(modalConversations);
    } else {
      setAddConvBtn(false);
      const modalConversations = filteredConversations.filter((chat) =>
        shortcutConv.find((conv) => conv._id === chat._id)
      );
      setModalConversations(modalConversations);
    }
    setEditShortcutModal(true);
  };

  //to select the conversation when user clicks the checkbox
  const handleUserSelect = (userId) => {
    if (selectedConversations.includes(userId)) {
      setSelectedConversations(
        selectedConversations.filter((id) => id !== userId)
      );
    } else {
      setSelectedConversations([...selectedConversations, userId]);
    }
  };

  const menu = (
    <Menu>
      <Menu.Item
        key="1"
        onClick={() => {
          deleteShortcut();
          setAllConversation(true);
        }}
      >
        Delete Shortcut
      </Menu.Item>
      <Menu.Item
        key="2"
        onClick={() => {
          handleEditShortcut(2);
        }}
      >
        Add conversation
      </Menu.Item>
      <Menu.Item
        key="3"
        onClick={() => {
          handleEditShortcut(3);
        }}
      >
        Remove conversation
      </Menu.Item>
    </Menu>
  );

  const [activeShortcutId, setActiveShortcutId] = useState(null);

  //A temporary solution to Conversation name (Will have to implement based on "isGroup")
  return (
    <div className="chats-container">
      {/* Search and filter component */}
      <div className="search-filter-component">
        <input
          type="text"
          value={searchQuery}
          onChange={handleInputChange}
          placeholder="Search or start a new chat"
          className="input-bar"
        />
        {/* Filter button */}
        <button
          className={`filter-btn ${
            unreadFlag ? "filter-btn-clicked" : "filter-btn-default"
          }`}
          onClick={() => setUnreadFlag(!unreadFlag)}
        >
          <BiFilter />
        </button>
      </div>

      {/* custom shortcut buttons */}
      {customShortcutData && customShortcutData.length !== 0 && (
        <div className="custom-filter-btn">
          <Button
            className={
              activeShortcutId === null ? "active-button" : "non-active"
            }
            onClick={() => {
              setActiveShortcutId(null);
              setAllConversation(true);
            }}
          >
            All
          </Button>
          {customShortcutData.map((shortcut, i) => (
            <Button
              key={i}
              className={
                activeShortcutId === shortcut._id
                  ? "active-button"
                  : "non-active"
              }
              style={{}}
              onClick={() => {
                setShortcutConv(shortcut.conversation);
                setShortcutId(shortcut._id);
                setActiveShortcutId(shortcut._id);
                setAllConversation(false);
              }}
            >
              {shortcut.shortName}
            </Button>
          ))}
        </div>
      )}

      {isLoading === true ? (
        <Loader />
      ) : allConversation ? (
        filteredConversations.length > 0 ? (
          filteredConversations.map((chat, i) => {
            if (chat.isGroup && rf) {
              if (chat.isGroup && chat.isRedFlag) {
                return (
                  <Chat
                    key={i}
                    isRedFlag={chat.isRedFlag}
                    pp={!chat.dp ? defaultDP : chat.dp}
                    contact={chatName(chat)}
                    active={true}
                    cID={chat._id}
                    descriptionn={chat.description}
                    usersOfThatGroup={chat.users}
                    unread={chat.messageCount}
                    mentionedIds={
                      chat.mentionedIds.length > 0 && chat.mentionedIds
                    }
                    createdByObj={chat.createdBy}
                    createdAtTime={chat.createdAt}
                    lastMessage={
                      chat.lastMessage.msg !== "" && chat.lastMessage.msg
                    }
                    lastMsgTime={
                      chat.lastMessage.msg !== "" && chat.lastMessage.time
                    }
                    onClick={() => handleChat(chat)}
                  />
                );
              } else {
                return null;
              }
            } else {
              if (chat.isGroup && unreadFlag) {
                if (chat.isGroup && chat.messageCount != 0) {
                  return (
                    <Chat
                      key={i}
                      isRedFlag={chat.isRedFlag}
                      pp={!chat.dp ? defaultDP : chat.dp}
                      contact={chatName(chat)}
                      active={true}
                      cID={chat._id}
                      descriptionn={chat.description}
                      usersOfThatGroup={chat.users}
                      createdByObj={chat.createdBy}
                      createdAtTime={chat.createdAt}
                      lastMessage={
                        chat.lastMessage.msg !== "" && chat.lastMessage.msg
                      }
                      lastMsgTime={
                        chat.lastMessage.msg !== "" && chat.lastMessage.time
                      }
                      unread={chat.messageCount}
                      mentionedIds={
                        chat.mentionedIds.length > 0 && chat.mentionedIds
                      }
                      onClick={() => handleChat(chat)}
                    />
                  );
                }
              } else {
                if (chat.isGroup) {
                  return (
                    <Chat
                      key={i}
                      isRedFlag={chat.isRedFlag}
                      pp={!chat.dp ? defaultDP : chat.dp}
                      contact={chatName(chat)}
                      active={true}
                      cID={chat._id}
                      descriptionn={chat.description}
                      usersOfThatGroup={chat.users}
                      createdByObj={chat.createdBy}
                      createdAtTime={chat.createdAt}
                      unread={chat.messageCount}
                      mentionedIds={
                        chat.mentionedIds.length > 0 && chat.mentionedIds
                      }
                      lastMessage={
                        chat.lastMessage.msg !== "" && chat.lastMessage.msg
                      }
                      lastMsgTime={
                        chat.lastMessage.msg !== "" && chat.lastMessage.time
                      }
                      onClick={() => handleChat(chat)}
                    />
                  );
                }
              }
            }
          })
        ) : (
          <div style={{ color: "grey", textAlign: "center" }}>
            No Conversations to Load
          </div>
        )
      ) : shortcutConv.length !== 0 && filteredConversations.length > 0 ? (
        filteredShortcutConv.map((chat, i) => {
          if (chat.isGroup && rf) {
            if (chat.isGroup && chat.isRedFlag) {
              return (
                <Chat
                  key={i}
                  isRedFlag={chat.isRedFlag}
                  pp={!chat.dp ? defaultDP : chat.dp}
                  contact={chatName(chat)}
                  active={true}
                  cID={chat._id}
                  descriptionn={chat.description}
                  usersOfThatGroup={chat.users}
                  unread={chat.messageCount}
                  mentionedIds={
                    chat.mentionedIds.length > 0 && chat.mentionedIds
                  }
                  createdByObj={chat.createdBy}
                  lastMessage={
                    chat.lastMessage.msg !== "" && chat.lastMessage.msg
                  }
                  lastMsgTime={
                    chat.lastMessage.msg !== "" && chat.lastMessage.time
                  }
                  onClick={() => handleChat(chat)}
                />
              );
            } else {
              return null;
            }
          } else {
            if (chat.isGroup) {
              return (
                <Chat
                  key={i}
                  isRedFlag={chat.isRedFlag}
                  pp={!chat.dp ? defaultDP : chat.dp}
                  contact={chatName(chat)}
                  active={true}
                  cID={chat._id}
                  descriptionn={chat.description}
                  usersOfThatGroup={chat.users}
                  unread={chat.messageCount}
                  mentionedIds={
                    chat.mentionedIds.length > 0 && chat.mentionedIds
                  }
                  createdByObj={chat.createdBy}
                  lastMessage={
                    chat.lastMessage.msg !== "" && chat.lastMessage.msg
                  }
                  lastMsgTime={
                    chat.lastMessage.msg !== "" && chat.lastMessage.time
                  }
                  onClick={() => handleChat(chat)}
                />
              );
            }
          }
        })
      ) : (
        <div>No red flagged conversations.</div>
      )}

      {!allConversation && (
        <div className="edit-shortcut-btn">
          <Dropdown overlay={menu} trigger={["click"]}>
            <a
              className="ant-dropdown-link"
              onClick={(e) => e.preventDefault()}
            >
              Edit Shortcut <DownOutlined />
            </a>
          </Dropdown>
          <Button type="primary" onClick={handleBroadcastModal}>
            Broadcast Message
          </Button>
        </div>
      )}

      <Modal
        title="Broadcast Message"
        visible={broadcastModal}
        onCancel={handleCancel}
        footer={null}
      >
        <Input
          type="text"
          value={broadcastMsg}
          onChange={handleBroadcastMsg}
          placeholder="Write Your Message"
        />

        <div className="modal-btn">
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            type="primary"
            onClick={() => {
              handleBroadcast();
              setBroadcastModal(false);
              // console.log(shortcutConv);
            }}
            disabled={broadcastMsg.length === 0}
          >
            Send
          </Button>
        </div>
      </Modal>

      <Modal
        title="Edit Shortcut"
        visible={editShortcutModal}
        onCancel={handleCancel}
        footer={null}
        bodyStyle={{
          maxHeight: "550px",
          overflow: "auto",
          paddingTop: "0",
          paddingBottom: "0",
        }}
      >
        <div className="edit-shortcut-modal">
          <div
            style={{
              position: "sticky",
              top: "0",
              padding: "10px 0",
              backgroundColor: "#fff",
              zIndex: "999",
            }}
          >
            <Input
              type="text"
              value={editSearchQuery}
              onChange={handleInputChange}
              placeholder="Search Conversations"
              className="modal-input-bar"
            />
          </div>

          {modalFilteredConversations.map((chat, i) => {
            if (chat.isGroup) {
              return (
                <div key={chat._id} className="modal-conversations">
                  <Checkbox
                    checked={selectedConversations.includes(chat._id)}
                    onChange={() => handleUserSelect(chat._id)}
                    className="rounded-checkbox"
                    style={{ zIndex: "10" }}
                  />
                  <img
                    className="profile-pic"
                    src={!chat.dp ? defaultDP : chat.dp}
                    alt="profile pic"
                  />
                  <h6 className="contact-name">{chatName(chat)}</h6>
                </div>
              );
            }
            return null;
          })}
        </div>
        <div className="modal-btn">
          <Button onClick={handleCancel}>Cancel</Button>
          {addConvBtn ? (
            <Button
              type="primary"
              onClick={() => {
                addConvToShortcut();
                setEditShortcutModal(false);
              }}
              disabled={selectedConversations.length === 0}
            >
              Add
            </Button>
          ) : (
            <Button
              type="primary"
              onClick={() => {
                deleteConvFromShortcut();
                setEditShortcutModal(false);
              }}
              disabled={selectedConversations.length === 0}
            >
              Remove
            </Button>
          )}
        </div>
      </Modal>
    </div>
  );
}

export default Chats;
